export default __webpack_public_path__ + "static/media/DIGITAL_FOODI_POINTAGE_illustrations_Acces.28f578b3.png";